// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface RanaDtacogoV1Input
 */
export interface RanaDtacogoV1Input {
  /**
   *
   */
  rainDuration?: number;
  /**
   *
   */
  tileInterval?: number;
  /**
   *
   */
  rainIntensity?: number;
  /**
   *
   */
  schematisation: RanaFile;
  /**
   *
   */
  simulationDuration?: number;
}

/**
 * Check if a given object implements the RanaDtacogoV1Input interface.
 */
export function instanceOfRanaDtacogoV1Input(value: object): value is RanaDtacogoV1Input {
  if (!("schematisation" in value) || value["schematisation"] === undefined) return false;
  return true;
}

export function RanaDtacogoV1InputFromJSON(json: any): RanaDtacogoV1Input {
  return RanaDtacogoV1InputFromJSONTyped(json, false);
}

export function RanaDtacogoV1InputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RanaDtacogoV1Input {
  if (json == null) {
    return json;
  }
  return {
    rainDuration: json["rain_duration"] == null ? undefined : json["rain_duration"],
    tileInterval: json["tile_interval"] == null ? undefined : json["tile_interval"],
    rainIntensity: json["rain_intensity"] == null ? undefined : json["rain_intensity"],
    schematisation: RanaFileFromJSON(json["schematisation"]),
    simulationDuration:
      json["simulation_duration"] == null ? undefined : json["simulation_duration"],
  };
}

export function RanaDtacogoV1InputToJSON(json: any): RanaDtacogoV1Input {
  return RanaDtacogoV1InputToJSONTyped(json, false);
}

export function RanaDtacogoV1InputToJSONTyped(
  value?: RanaDtacogoV1Input | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    rain_duration: value["rainDuration"],
    tile_interval: value["tileInterval"],
    rain_intensity: value["rainIntensity"],
    schematisation: RanaFileToJSON(value["schematisation"]),
    simulation_duration: value["simulationDuration"],
  };
}
